import { useEffect, useState } from 'react';
import { getPostsWP } from '../../actions/api';

function useGetUserPosts(userId, type) {
    const [ items, setItems ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ isError, setError ] = useState(false);

    useEffect(() => {
        const getItems = async () => {
            setError(false);
            setLoading(true);
            try {
                const json = await getPostsWP(userId, type);
                setItems(json);
                setLoading(false);
            }
            catch (error) {
               setError(error);
            }
        }
        if(userId)getItems();
    },[userId, type]);
    return [items, loading, isError];
}

export default useGetUserPosts;